import { h, render, Component } from 'preact';
import TxrNavbar from './txr-navbar';
import { classNames } from '../utils/utils';

class TxrBottomCaseStudy extends Component {

    render() {
        return (
            <div class="txr-bottom-case-study">
                <div class="case-study__top-image"></div>
                <div class="case-study-items">
                    <img class="case-study__image-profile" src="/images/home/profile-fpo.png" />
                    <div class="case-study-quotes">
                        <div class="case-study-quote">
                            “
                    </div>
                        <div class="case-study-quotes__text">
                            The message templates are my favorite feature, because they save me so much time. With Text Request I know I can always keep my members connected. It’s an awesome, quick way to stay in touch!”
                    </div>
                        <div class="case-study-quotes__owner">
                            Abbie Peraza, Owner Studio Pop
                    </div>
                        <div class="case-study-quotes__name">
                            Studio Pop
                   </div>
                        <div class="section-item__link">
                            <a class="txr-angle__link" href="/Home/Index">View Case Study  <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TxrBottomCaseStudy;